var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"imageMapContainer",staticClass:"image-map-container",attrs:{"id":"image-map-pro"}})
}
var staticRenderFns = []

export { render, staticRenderFns }